import { createSelector, MemoizedSelector } from '@ngrx/store';
import { CopyrightPayload } from '@ispm/widgets/components/copyright.component/interfaces/copyright-payload.interface';
import { selectCurrentConfig } from '../../../../app/configuration/store/configuration.selector';

/**
 * Created By Alon Yampolski on 28/3/18
 */

export const selectCopyrightParams: MemoizedSelector<object, CopyrightPayload> =
  createSelector(selectCurrentConfig('Test'), testDefinition => testDefinition.copyright);
